import { render, staticRenderFns } from "./robotAvatarManagement.vue?vue&type=template&id=a92c787a&scoped=true"
import script from "./robotAvatarManagement.vue?vue&type=script&lang=js"
export * from "./robotAvatarManagement.vue?vue&type=script&lang=js"
import style0 from "./robotAvatarManagement.vue?vue&type=style&index=0&id=a92c787a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92c787a",
  null
  
)

export default component.exports